
import Vue from "vue";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { PROMO_CODES } from "@/store/promoCodes";
import { ROUTE_NAMES } from "@/routes";
import { isInSomeRole } from "@/helpers/auth";
import { PRICING_TEAM, SUPPORT } from "@/constants/roles";
import store from "@/store";

export default Vue.extend({
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.promoOffer.dataTable.pagination;
      },
      set(value: string) {
        this.$store.commit(
          PROMO_CODES.NS(PROMO_CODES.MUTATIONS.SET_DATA_TABLE_PAGINATION),
          value
        );
      }
    },
    hasEditAccess() {
      return isInSomeRole([PRICING_TEAM, SUPPORT]);
    },
    detailRouteName: () => ROUTE_NAMES.PROMO_CODE_DETAIL,
    ...mapState({
      promoCodesList: (state: IRootState) => state.promoOffer.promoCodesList
    })
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: this.detailRouteName,
        params: { id: item.id }
      });
    },
    onPagination(value: any) {
      this.pagination = value;
    }
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(
      PROMO_CODES.NS(PROMO_CODES.ACTIONS.LOAD_PROMO_OFFER_LIST)
    );

    this.isLoading = false;
  }
});
